<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";

export default {
  page: {
    title: "Automated Tasks",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {PageHeader, Layout},
name: "default",
  data() {
    return {
      title: "Automated Tasks",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Automated Tasks",
          active: true
        }
      ],
    }
  }
}
</script>

<style scoped>

</style>
